<div class="tw-flex tw-flex-col tw-h-full tw-bg-teal-200 tw-relative">
  <div class="tw-flex tw-absolute tw-top-15 tw-left-5 tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
    <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
  </div>
  <div class="tw-flex-1"></div>
  <div class="tw-w-full tw-flex tw-items-center tw-justify-between tw-pl-6 tw-relative">
    <div class="tw-font-lexend tw-mb-5">
      <p class="tw-text-300 tw-uppercase tw-mb-2">{{user?.get('PatientName')?.split(" ")?.[0]}},</p>
      <p class="tw-font-bold tw-text-gray-800 tw-w-[60%]" [class.tw-text-600]="isDravidianScriptUser" [class.tw-text-700]="!isDravidianScriptUser" i18n='@@whatCanWeHelpWith'>What can we help you with?</p>
    </div>
    <img class="tw-w-40 tw-absolute -tw-bottom-10 -tw-right-4 tw-z-0" src="/assets/images/dr-charu.png" alt="Dr Charu" />
  </div>
  <regimen-concern-selection class="tw-bg-white tw-rounded-t-5 tw-h-[65%] tw-z-10 tw-p-5 tw-pt-14"
                             [acqRebranding2025]="acqRebranding2025"
                             [concernClass]="selectedConcernClass"
                             [gender]='user?.get("Gender")'
                             (selectConcern)="updateConcern($event)"></regimen-concern-selection>
</div>
